<template>
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="-0.5" width="26.6543" height="27" rx="8.5" transform="matrix(1 0 0 -1 0 27)" stroke="white"/>
    <path d="M12.2436 18.4609C11.9624 18.4609 11.7749 18.6719 11.7749 18.9297V20.0312C11.7749 20.3125 11.9624 20.5 12.2436 20.5H15.8061C16.0639 20.5 16.2749 20.3125 16.2749 20.0312V18.9297C16.2749 18.6719 16.0639 18.4609 15.8061 18.4609H15.3374V13.4688C15.3374 13.2109 15.1264 13 14.8686 13H12.2436C11.9624 13 11.7749 13.2109 11.7749 13.4688V14.5938C11.7749 14.8516 11.9624 15.0625 12.2436 15.0625H12.7124V18.4609H12.2436ZM14.0249 8.5C13.0874 8.5 12.3374 9.27344 12.3374 10.1875C12.3374 11.125 13.0874 11.875 14.0249 11.875C14.9389 11.875 15.7124 11.125 15.7124 10.1875C15.7124 9.27344 14.9389 8.5 14.0249 8.5Z" fill="white"/>
</svg>
</template>

<script>
    export default {
        name:"InformationIcon"
    }
</script>